import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import close2 from '../../assets/generalItems/deleteCrossGray.png'

export function Information() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!document.body) {
      return
    }
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        navigate('/planner')
      }
    }
    document.body.addEventListener('keydown', handleKey)
    return () => {
      document.body.removeEventListener('keydown', handleKey)
    }
  }, [])

  return (
    <div className='absolute left-1/2 top-1/2 z-20 h-screen w-screen -translate-x-1/2 -translate-y-1/2 bg-white opacity-[95%]'>
      <img className=' absolute left-1/2 top-1/2 z-50 h-full w-full -translate-x-1/2 -translate-y-1/2 bg-bgInfo bg-contain bg-center bg-no-repeat' />

      <div
        className='absolute right-10 top-5 z-50 cursor-pointer'
        onClick={() => {
          navigate('/planner')
        }}
      >
        <img
          role='button'
          src={close2}
        />
      </div>
    </div>
  )
}
